import React, {Component} from 'react';
import classNames from 'classnames';

export default class EpicContentCreators extends Component {
    render(){
        const {displayStatic} = this.props;
        const macBookImg = require('images/branded_content/epic_content_creators_dash.png');
        const mobileMacBookImg = require('images/branded_content/mobile_epic_content_creators.png');
        const epicContentCreatorsTextClassnames = classNames('epic-content-creators-text', {
            'epic-content-creators-text-web-static': displayStatic
        });

        return(
            <div className='gr-12 epic-content-creators'>
                <div className={epicContentCreatorsTextClassnames}>
                    <h1>Connect with 14 million epic content creators</h1>
                    <p>Social Native’s platform matches brands with relevant creators based on interests and brand affinities. Brands can create a library of owned content that can be used and reused across all marketing channels.</p>
                </div>

                <div className='show hide@xs epic-content-creators-media'>
                    <img src={macBookImg} className='epic-content-creators-macbook-image' />
                </div>

                <div className='hide show@xs epic-content-creators-img-mobile'>
                    <img src={mobileMacBookImg} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/branded_content/epic_content_creators.js